import React from 'react';
import { Link } from 'react-router-dom';

const BlogKinhNghiemLaiXePage = () => {
    return (
        <main className="product-category" style={{ borderBottom: '1px solid #ececec', paddingBottom: 20 }}>
            {/* ════ MINIMAL BREADCRUMBS ════ */}
            <div className="py-4 mt-[50px]">
                <div className="container px-4 text-left">
                    <nav aria-label="breadcrumb">
                        <ol className="flex items-center gap-2 text-xs md:text-sm uppercase tracking-wider mb-0 p-0 list-none">
                            <li className="breadcrumb-item">
                                <Link to="/" className="hover:text-red-600 transition-colors no-underline text-slate-500">Trang chủ</Link>
                            </li>
                            <span className="opacity-30">/</span>
                            <li className="breadcrumb-item">
                                <Link to="/blog" className="hover:text-red-600 transition-colors no-underline text-slate-500">Blog</Link>
                            </li>
                            <span className="opacity-30">/</span>
                            <li className="breadcrumb-item active text-slate-900 font-bold" aria-current="page">
                                Kinh Nghiệm Lái Xe
                            </li>
                        </ol>
                    </nav>
                </div>
            </div>

            <div className="container">
                <h1 className="heading-primary text-center" style={{ margin: '60px 0' }}>
                    <span>Kinh Nghiệm Lái Xe</span>
                </h1>
                <p className="text-center">
                    Trang chuyên mục chia sẻ kinh nghiệm lái xe an toàn, tiết kiệm, xử lý tình huống trên đường...
                </p>
            </div>
        </main>
    );
};

export default BlogKinhNghiemLaiXePage;




